import { Component, OnInit } from '@angular/core';

// RxJs
import { take } from 'rxjs';

// NgRX
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/reducers';
// import { selectNetworkCookieState } from '@core/store/selectors/network.selectors';
// import { SecurityEffectsActions } from '@core/store/actions';

// ENVs
import { environment as ENV } from '@environments/environment';
import { SessionEffectsActions } from '@core/store/actions/session.actions';



@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: [ './unauthorized.component.scss' ]
})
export class UnauthorizedComponent implements OnInit {

  public icon!: string;
  public title!: string;
  public paragraph!: string;
  public button!: string;
  public advise!: string;

  private redirectTo: string | null;


  constructor(
    private readonly store: Store<AppState>
  ) {
    this.redirectTo = null;
  }


  ngOnInit(): void {
    // this.store.select(selectNetworkCookieState).pipe(take(1))
    // .subscribe(({ authorization }) => {
    //   this.initializeVars(authorization ? ValidationToken.INVALID_TOKEN : ValidationToken.WITHOUT_TOKEN);
    // });
    this.initializeVars(ValidationToken.INVALID_TOKEN);
  }


  private initializeVars(validationToken: ValidationToken): void {
    switch (validationToken) {
      case ValidationToken.INVALID_TOKEN:
        this.icon = 'stop-hand.svg';
        this.title = '¡Lo sentimos! No tienes permitido acceder al sistema';
        this.paragraph = 'Por favor, ponte en contacto con un administrador para <br />' +
          'habilitar tu cuenta en el sistema.';
        this.button = 'Salir';
        this.advise = '';
        break;

      default:
        this.icon = 'stop-hand.svg';
        this.title = '¡Lo sentimos! No has iniciado sesión en el sistema';
        this.paragraph = 'Por favor, inicia sesión para <br />' +
          'poder acceder al sistema.';
        this.button = 'Iniciar sesión';
        this.advise = 'Inicia sesión para poder acceder al sistema.';
        this.redirectTo = 'ENV.SECURITY.REDIRECT_401';
        break;
    }
  }


  public logOut(): void {
    this.store.dispatch(SessionEffectsActions.logOut());
  }
}

enum ValidationToken {
  WITHOUT_TOKEN,
  INVALID_TOKEN
}
